/**
 * Created by jv on 2019-09-19 (12:14).
 */
import utils from "Sources/utils/utils";
import moment from "moment";
import CONSTANTS from "Sources/config/constants";

class GameSessionMessage
{
  constructor(options)
  {
    this.id = options.id || utils.UUID();

    this.type = options.type || "request";
    this.service = options.service;
    this.error = options.error;

    this.data = options.data;

    this.params = options.params;
  }

  serialize()
  {
    let data = {
      id: this.id,

      type: this.type,
      service: this.service,
      error: this.error,

      data: this.data,

      params: this.params,

      sent: moment.utc().format(CONSTANTS.API_DATE_FORMAT)
    };

    return utils.stringifyJSON(data);
  }

  static createRequest(serviceName, params, data)
  {
    return new GameSessionMessage({
      service: serviceName,
      params,
      data
    });
  }

  static createResponse(serviceName, params, data)
  {
    return new GameSessionMessage({
      type: "response",
      service: serviceName,
      params,
      data
    });
  }

  static createErrorMessage(errorCode, params, data)
  {
    return new GameSessionMessage({
      type: "error",
      error: errorCode,
      params,
      data
    });
  }
}

export default GameSessionMessage;



// WEBPACK FOOTER //
// ./app/js/models/game-session-message.js